import PageTemplate from "./PageTemplate";
import Experience from "../../../Experience";
import Home from "./Home";

export default class Contact {
    constructor() {
        this.experience = new Experience()
        this.home = new Home()
        this.interaction = this.home.interaction
        this.resources = this.experience.resources

        if (this.resources.loaded === this.resources.toLoad) {
            this.setup()
        }
        else {
            this.resources.on("ready", () => {
                this.setup()
            })
        }
    }

    setup() {
        this.contact1Image = this.resources.items.mail
        this.contact2Image = this.resources.items.github
        this.contact3Image = this.resources.items.itch
        this.contact4Image = this.resources.items.resume
        this.contact1 = [
            "Email",
            this.contact1Image,
            "abhishekgusain798@gmail.com",
            "mailto:abhishekgusain798@gmail.com"
        ]
        this.contact2 = [
            "Github",
            this.contact2Image,
            "github.com/AbhishekGusain1289",
            "https://github.com/AbhishekGusain1289"
        ]
        this.contact3 = [
            "Itch.io",
            this.contact3Image,
            "https://abhishekgusain.itch.io/",
            "https://abhishekgusain.itch.io/"
        ]

        this.contact4 = [
            "Resume",
            this.contact4Image,
            "Resume.pdf",
            "/files/Abhishek_Gusain.pdf"
        ]
        this.contactList = [this.contact1, this.contact2, this.contact3, this.contact4]

        this.template = new PageTemplate(
            "Contact",
            "#FE1515",
            "#F9ED49",
            this.contactList
        )
    }

    destroy() {
        this.template.destroy()
    }
}